export interface VulnerabilityData {
  slug: string
  name: string
  value: number
}

export enum FilterType {
  SEVERITY = 'severity',
  REACHABILITY = 'reachability'
}
